import { SelectOption } from './types'

// Generates an array of objects with the days of the month (from 1 to 31)
export const generateDayOptions = (): SelectOption[] => {
	return Array.from({ length: 31 }, (_, i) => {
		const day = (i + 1).toString().padStart(2, '0')
		return { label: (i + 1).toString(), value: day }
	})
}
